import React from 'react';

import { OpportunityProvider } from 'generated/graphql';
import VolunteerMatch from 'assets/opportunityProviders/VolunteerMatch.svg';
import VolunteerGov from 'assets/opportunityProviders/VolunteerGov.svg';
import PointsOfLight from 'assets/opportunityProviders/PointsOfLight.svg';
import Idealist from 'assets/opportunityProviders/Idealist.svg';
import Goodera from 'assets/opportunityProviders/Goodera.svg';
import Img from 'retired/Img';
import { opportunityProviderLabelsMap } from 'shared/opportunityProviders';

type SupportedOpportunityProvider = Exclude<
  OpportunityProvider,
  | OpportunityProvider.Betterplace
  | OpportunityProvider.GlobalGiving
  | OpportunityProvider.Catchafire
>;

const providerLogos: Record<SupportedOpportunityProvider, string> = {
  VolunteerMatch,
  VolunteerGov,
  PointsOfLight,
  Idealist,
  Goodera,
};

export const ProviderLogo = ({
  provider,
  style,
}: {
  provider: OpportunityProvider;
  style?: React.CSSProperties;
}) => (
  <Img
    src={providerLogos[provider as SupportedOpportunityProvider]}
    alt={opportunityProviderLabelsMap[provider]}
    style={{ height: 20, margin: '15px auto', display: 'block', ...style }}
  />
);
